import { FC } from 'react';
import { TPointSummary } from '../../../../../features/main-map/mapTypes';

export interface IPopupProps {
	info: TPointSummary;
}

const SignalHoverPopupContent: FC<IPopupProps> = (props: IPopupProps) => {
	return (
		<div className="grid grid-cols-1 gap-y-0 text-center">
			{/* <span className="font-bold text-msi-midblue-color-500 text-right pr-2">{props.type}</span> */}
			<span>{props?.info?.name}</span>
		</div>
	);
};

export default SignalHoverPopupContent;
